<!DOCTYPE html>
<html lang="en">
  <head>
    <!-- Required meta tags -->
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>NorsupOne</title>
  </head>
  <body>
    <div class="container-fluid">
      <div class="row gx-0">
        <div class="col-lg-12">
          <div class="side-menu">
            <app-side-bar></app-side-bar>
          </div>
          <div class="right-side">
            <div class="pt-3">
              <div class="glass-bg w-100 profile-card-block">
                <div class="profile-card px-3 text-center">
                  <div class="user-avatar pb-3"><img
                      [src]="profileImage" /></div>
                  <h5>{{fullName}}</h5>
                  <p>{{userName}}</p>
                  <div class="change-password" (click)="changePassword()"><img src="assets/img/key.svg"> Change password</div>
                  <a class="profile-edit"><img
                      src="assets/img/profile-edit.svg" (click)="editProfileView()"/></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </body>
</html>
